export default __webpack_public_path__ + "static/media/allgemein_14.86737a41.jpg";